import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { CustomFieldDisplay } from "~/components/CustomFieldDisplay";
export const CustomFieldsDisplay = /*#__PURE__*/ memo((param)=>{
    let { className, customFields, onClick, shouldShowLabelInline, style } = param;
    return /*#__PURE__*/ _jsx("button", {
        "data-testid": "CUSTOM_FIELDS_INDICATOR",
        className: classNames("pointer-events-auto flex max-w-full flex-col gap-1 text-left hover:bg-transparent", className),
        disabled: !onClick,
        onClick: onClick,
        style: style,
        children: customFields.map((cfValue)=>/*#__PURE__*/ _jsx(CustomFieldDisplay, {
                shouldShowLabelInline: shouldShowLabelInline,
                cfValue: cfValue
            }, cfValue.id))
    });
});
CustomFieldsDisplay.displayName = "CustomFieldsDisplay";
